import Vue from 'vue'
import Router from 'vue-router'
import WebHistory from 'vue-router'

Vue.use(Router)

const routes = [
 {
    path: '/Homepage',
    component: () => import('@/routes/Homepage'),
    name: 'Homepage'
  },
  {
    path: '/Teams',
    alias: '/Partners',
    component: () => import('@/routes/FilterVue'),
    name: 'Teams',
    meta: {
      scrollPos: {
          top: 0,
          left: 0,
      },
    },
  },
  { 
    path: '/', 
    redirect: '/Homepage' 
  },
  {
    path: '/Team',
    alias: '/Partner',
    component: () => import('@/routes/TeamPartner'),
    name: 'TeamPartner'
  },
  {
    path: '/AboutUs',
    component: () => import('@/routes/AboutUs'),
    name: 'AboutUs'
  },
  {
    path: '/PrivacyPolicy',
    component: () => import('@/routes/PrivacyPolicy'),
    name: 'PrivacyPolicy'
  },
  {
    path: '/Terms',
    component: () => import('@/routes/TermsAndConditions'),
    name: 'Terms'
  }
]

const scrollBehavior = (to, from, savedPosition) => {
  const scrollpos = savedPosition ||
      to.meta?.scrollPos ||
      { left: 0, top: 0 }
  return new Promise((resolve) => {
      setTimeout(() => {
          resolve(scrollpos)
      }, 600) // transition just before 600ms
  })
}

const router = new Router({
  history: new WebHistory(),
  scrollBehavior,
  routes
});

router.beforeEach((to, from, next) => {
  console.log('window.scrollY:', window.scrollY)
  from.meta?.scrollPos && (from.meta.scrollPos.top = window.scrollY)
  console.log('from:\t', from.name, '\t', from.meta?.scrollPos)
  console.log('to:\t\t', to.name, '\t', to.meta?.scrollPos)
  return next()
})

export default router;